import { useCallback, useContext, useEffect, useRef, useState } from "react";
import contextBabylon from "../../../../../../../context/index.js";
import { SearcherModalProductType } from "../../../types.js";
import { getActivitiesSearcher, getFerryHotelSearcher, getFlightHotelSearcher, getTrainHotelSearcher } from "../service.js";
const getProduct = (props)=>{
    if (props.product) return props.product.toUpperCase();
    if (!props.searcher) return SearcherModalProductType.FERRYHOTEL;
    if ('product' in props.searcher) {
        if (typeof props.searcher.product === 'string') return props.searcher.product.toUpperCase();
    }
};
export const useSearcherModal = (props)=>{
    const { endpoint ='' , endpointParams ={} , searcher ={} , literals  } = props;
    const [config, setConfig] = useState({
        onModal: true,
        hideDestination: true
    });
    const product = getProduct(props);
    const { BaseUrl  } = useContext(contextBabylon);
    const [flightHotelData, setFlightHotelData] = useState();
    const [trainHotelData, setTrainHotelData] = useState();
    const [ferryHotelData, setFerryHotelData] = useState();
    const [fliData, setFliData] = useState();
    const [ferData, setFerData] = useState();
    const [activitiesData, setActivitiesData] = useState();
    const [loading, setLoading] = useState(true);
    const callLock = useRef(false);
    const getApiService = useCallback((productType)=>{
        const searcherPromise = ()=>Promise.resolve(searcher);
        const apiService = {
            [SearcherModalProductType.ROUNDTRIP]: {
                service: searcherPromise,
                setState: setFliData
            },
            [SearcherModalProductType.ONEWAY]: {
                service: searcherPromise,
                setState: setFliData
            },
            [SearcherModalProductType.FLIGHTHOTEL]: {
                service: getFlightHotelSearcher,
                setState: setFlightHotelData
            },
            [SearcherModalProductType.TRAINHOTEL]: {
                service: getTrainHotelSearcher,
                setState: setTrainHotelData
            },
            [SearcherModalProductType.FERRYHOTEL]: {
                service: getFerryHotelSearcher,
                setState: setFerryHotelData
            },
            [SearcherModalProductType.ACTIVITIES]: {
                service: getActivitiesSearcher,
                setState: setActivitiesData
            },
            [SearcherModalProductType.FERRY]: {
                service: searcherPromise,
                setState: setFerData
            },
            [SearcherModalProductType.SEARCHER_FLIGHT_HOTEL]: {
                service: searcherPromise,
                setState: setFlightHotelData
            },
            [SearcherModalProductType.SEARCHER_TRAIN_HOTEL]: {
                service: searcherPromise,
                setState: setTrainHotelData
            },
            [SearcherModalProductType.SEARCHER_FERRY_HOTEL]: {
                service: searcherPromise,
                setState: setFerryHotelData
            },
            [SearcherModalProductType.SEARCHER_ACTIVITIES]: {
                service: searcherPromise,
                setState: setActivitiesData
            }
        };
        return apiService[productType] || {};
    }, [
        searcher
    ]);
    const getData = useCallback(()=>{
        if (!callLock.current) {
            const productType = product?.toUpperCase();
            callLock.current = true;
            const { service , setState  } = getApiService(productType);
            if (productType === SearcherModalProductType.ONEWAY || productType === SearcherModalProductType.ROUNDTRIP) {
                setLoading(false);
                setState(searcher);
                setConfig((prevState)=>({
                        ...prevState,
                        literals
                    }));
                callLock.current = false;
                return;
            }
            setLoading(true);
            service?.(endpoint, endpointParams, BaseUrl).then(setState).finally(()=>{
                setLoading(false);
                callLock.current = false;
            });
        }
    }, [
        BaseUrl,
        endpoint,
        endpointParams,
        product,
        getApiService,
        searcher,
        literals
    ]);
    useEffect(()=>{
        if (loading) getData();
    }, [
        getData,
        product,
        searcher,
        loading
    ]);
    return {
        flightHotelData,
        trainHotelData,
        ferryHotelData,
        fliData,
        ferData,
        activitiesData,
        loading,
        config,
        product
    };
};
export default useSearcherModal;

//# sourceMappingURL=useSearcherModal.js.map